//=====================================================
//　G019：キャンセル確認
//=====================================================

import { useContext, useState } from "react";
import { ContentsBox } from "../../common/ContentsBox";
import { BtnSubmit } from "../../common/BtnSubmit";
import { ContentsTitle } from "../../common/ContentsTitle";
import { ReservationInfo } from "../../common/ReservationInfo";
import { BtnReturn } from "../../common/BtnReturn";
import { CtxClinicInfo, CtxNewReservation, CtxPatientInfo, CtxSystemErr } from "../../utils/Contexts";
import { delApiDataWithToken } from "../../utils/CallApi";
import { useAuth } from "../../utils/UseAuth";
import { AxiosResponse } from "axios";
import { MsgBoxErr } from "../../common/MsgBoxErr";
import { ConstMsg } from "../../utils/ConstMsg";
import { useHistory } from "react-router-dom";
import { LoadingBox } from "../../common/LoadingBox";
import { useEffect } from "react";
import { LoginStatusType } from "../../utils/ConstCommon"

export function G019(){
    const [errmess, setErrmess] = useState('');
    const history = useHistory();
    const cserr = useContext(CtxSystemErr);
    const cci = useContext(CtxClinicInfo);
    const cpi = useContext(CtxPatientInfo);
    const cnr = useContext(CtxNewReservation);

    const ua = useAuth();
    const token = ua.getToken();

    const [loadingDone, setLoadingDone] = useState(true);

    // ブラウザバックで表示させない処理
    useEffect(function(){
        //タイトル追加処理
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - キャンセル確認";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - キャンセル確認";
        }

        // マウントフラグ
        let isMounted = true;

        // アンマウント時はstate(history)を更新しないようにする
        if(isMounted){
            // 完了データの場合、マイページ、トップへ遷移
            if(cnr.data.done){
                if(ua.isLoggedIn()){
                    history.push('/mypage');
                } else {
                    history.push('/');
                }
            }
        }

        // cleanup関数(Unmount時の処理)
        return () => {
            // マウントオフ
            isMounted = false;
        }
        // アンマウント時にのみ一回だけ実行したいため第2引数指定なし。
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    //キャンセルボタンクリック処理
    function clickCancel(){
        if( ua.checkExpiresIn() !== LoginStatusType.Login ){
            //ログアウト、ログイン期限切れ
            ua.logout(function(){history.push("/")});
        }else{
            setLoadingDone(false);
            let apiUrl = `/auth/c/${cci.data.id}/reservations/${cnr.data.reserveId}`;
            let apiParams = {
                data: {
                    patientId: cpi.data.patientId
                }
            };
                        
            //予約情報削除
            delApiDataWithToken(apiUrl, apiParams, token,
                function(res:AxiosResponse<any>){
                    setLoadingDone(true);
                    if (res?.data) {
                        if(res.status === 200 ){
                            //正常ケース
                            setErrmess("");
                            cnr.update({done:true});
                            history.push('/mypage/cancel/complete')
                        } else if( res.status === 400 ){
                            setErrmess(res.data.message);
                        } else if( res.status === 403 || res.status === 404 || res.status >= 500 ){
                            cserr.setErrmess(res.data.message);
                        } else {
                            cserr.setErrmess(ConstMsg.EG9990001);
                        }
                    } else {
                        cserr.setErrmess(ConstMsg.EG9990001);
                    }
                }
            );
        }
    }

    return (
        <>
            <ContentsBox>
                <ContentsTitle title="以下のご予約をキャンセルします" />
                {errmess && <MsgBoxErr text={errmess} />}
                <LoadingBox overlay={true} loadingDone={loadingDone}>
                    <ReservationInfo />
                    <BtnSubmit title="予約をキャンセルする"  onClick={function(){clickCancel()}}/>
                </LoadingBox>
            </ContentsBox>
            <BtnReturn />
        </>
    );

}